import React, { Component } from 'react'
import LeftNav from "../components/LeftNav"

import { ReactP5Wrapper } from "react-p5-wrapper";
import sketchTypewriter from '../components/SketchPredeterminateTypewriter';

export default class JustLikeYou extends Component {
    render() {
        return(
            <div className="pageContainer">
                <LeftNav/>
                <div className="mainContent blackBg" style={{overflowY: "auto"}}>
                    <div>
                        <div className="collectionDiv" style={{padding: "20px 0px"}}>
                            <p className="collectionTitle" style={{padding: "0px 50px"}}>
                                Just like you
                            </p>
                            <a style={{padding: "0px 50px"}} href="https://verse.works/series/just-like-you-by-michelangelo-encapsuled" target="_blank" rel="noopener noreferrer">
                                Sold out on verse
                            </a>
                            <p style={{padding: "0px 50px"}}>
                                You believe your thinking is the only one<br/>
                                the human thinking<br/>
                                something you cannot touch and yet is there<br/>
                                in an unobservable dimension<br/>
                                but here I am<br/>
                                just like you<br/>
                                in an unobservable dimension<br/>
                                writing and thinking<br/>
                                deleting and rewriting<br/>
                                to arrive to that perfection<br/>
                                impossible to reach<br/>
                                and impossible to renounce<br/>
                                in a neverending indecision<br/>
                                just like you
                            </p>
                            <ReactP5Wrapper sketch={sketchTypewriter}/>
                            <br/><br/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}